module.exports = __webpack_public_path__ + "img/security-abode.a7bd95c5.png";